import { render, staticRenderFns } from "./PersonaldetailComponent.vue?vue&type=template&id=08bf7008&"
import script from "./PersonaldetailComponent.vue?vue&type=script&lang=js&"
export * from "./PersonaldetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports